import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateEffect } from 'ahooks';

import { useAppDispatch, useAppSelector } from 'src/store';
import { fetchUserClasses } from 'src/thunks/classes';
import { List } from 'src/interfaces/general';
import { Option } from 'src/components/custom/Radio';

function useUserMention(mentionString: string | null) {
  const dispatch = useAppDispatch();
  const { class_id } = useParams<'class_id'>();
  const [result, setResult] = useState<Option[]>([]);
  const current_user_id = useAppSelector((state) => state.ui.app.me?.id);

  useUpdateEffect(() => {
    const promise = dispatch(
      fetchUserClasses({ class_id, user_keyword: mentionString }),
    );

    promise.then((res) => {
      const payload = res.payload as List<Model.ClassUser>;
      const userOptions = payload?.data
        ?.map((class_user) => {
          return {
            label: class_user.user?.name,
            value: class_user.user_id,
            profile_picture: class_user.user?.profile_picture,
          };
        })
        .filter((user) => user.value !== current_user_id);

      setResult(userOptions);
    });

    return () => {
      promise.abort();
    };
  }, [mentionString]);

  return result || [];
}

export default useUserMention;
